export {default} from './MainBanner'